<template>
    <v-toolbar ref="main-toolbar" fixed class="amber">
        <v-btn v-if="!isTopLevel" icon light @click.stop="back()">
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-side-icon v-else @click.stop="toggleSidebar()" light></v-toolbar-side-icon>
        <v-toolbar-title v-text="$store.state.nav.title" style="position: relative" class="d-flex"></v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="showProfile()" class="hidden-sm-and-down">
            <v-menu offset-y>
                <v-avatar slot="activator">
                    <img :alt="profile.name" :src="profile.picture"></img>
                </v-avatar>
                <v-card>
                    <v-list three-line dense>
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <img v-bind:src="profile.picture">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title v-html="profile.name"></v-list-tile-title>
                                <v-list-tile-sub-title class="grey--text text--darken-4" v-html="profile.email"></v-list-tile-sub-title>
                                <v-list-tile-sub-title v-html="profile.sub"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn primary flat @click="signOut()">Sign out</v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </div>
    </v-toolbar>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { isAuthenticated } from '../store/auth';

    export default {
        name: 'main-toolbar',
        computed: {
            ...mapGetters('auth', [
                'profile',
            ]),
            isTopLevel() {
                return this.$store.state.route.fullPath.indexOf('/', 1) === -1;
            },
        },
        methods: {
            showProfile() {
                return isAuthenticated();
            },
            toggleSidebar() {
                this.$store.commit('nav/SIDEBAR', !this.$store.state.nav.sidebar);
            },
            back() {
                this.$router.go(-1);
            },
            signOut() {
                this.$store.commit('auth/LOGOUT');
                this.$router.push({ path: '/login' });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// MainToolbar.vue?b4bdfb04